import * as React from 'react';
import TextField from '@mui/material/TextField';
import debounce from 'lodash/debounce';

export interface SearchInputProps {
  value: string | null;
  placeholder: string;
  setValue(x: string): void;
}

const SearchInput = ({ value, setValue, placeholder }: SearchInputProps) => {
  const [localValue, setLocalValue] = React.useState(value ?? '');

  React.useEffect(() => {
    setLocalValue(value ?? '');
  }, [value]);

  const debouncedSetValue = React.useMemo(() => debounce((v: string) => setValue(v), 600), [setValue]);

  React.useEffect(() => {
    return () => debouncedSetValue.cancel();
  }, [debouncedSetValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setLocalValue(input);
    debouncedSetValue(input);
  };

  return (
    <TextField
      size="small"
      sx={{ width: '100%', bgcolor: '#ffffff', borderRadius: '5px' }}
      placeholder={placeholder}
      value={localValue}
      onChange={handleChange}
    />
  );
};

export default SearchInput;
